import { render, staticRenderFns } from "./vip-phone-login1.vue?vue&type=template&id=554f319f&scoped=true&"
import script from "./vip-phone-login1.vue?vue&type=script&lang=js&"
export * from "./vip-phone-login1.vue?vue&type=script&lang=js&"
import style0 from "./vip-phone-login1.vue?vue&type=style&index=0&id=554f319f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f319f",
  null
  
)

export default component.exports